'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcTopPrev(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcTopPrev');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02107 1L1 9.02107L9.02107 17",
    stroke: fill || '#1E1E23',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var IcTopPrev$1 = /*#__PURE__*/memo(IcTopPrev);

export { IcTopPrev$1 as default };
